import Label from './Label'
import { withTooltip } from 'common/hooks/useTooltip'
export { LabelSet, LabelGroup, LabelSpacer } from './Label'

export default withTooltip(Label)
